import makeApiCall from "./axiosIndex";

const workUomApi = {
    createWorkUom: (data: any): Promise<any> =>
        makeApiCall<any>({
            method: "post",
            url: "buyer/createWorkUom",
            data,
        }),

    fetchWorkUoms: (): Promise<any> =>
        makeApiCall<any>({ method: "get", url: "/buyer/fetchWorkUoms" }),

    fetchWorkUomById: (id: any): Promise<any> =>
        makeApiCall<any>({
            method: "get",
            url: `/buyer/fetchWorkUomById`,
            params: { id },
        }),

    activateWorkUomById: (id: any): Promise<any> =>
        makeApiCall<any>({
            method: "put",
            url: `/buyer/activateWorkUomById`,
            data: { id },
        }),

    inactivateWorkUomById: (id: any): Promise<any> =>
        makeApiCall<any>({
            method: "put",
            url: `/buyer/inactivateWorkUomById`,
            data: { id },
        }),

    fetchWorkUomWithPagination: (params: any): Promise<any> => {
        return makeApiCall({
            url: "/buyer/fetchWorkUomWithPagination",
            method: "get",
            params,
        });
    },
};

export default workUomApi;

